import BaseApi from './BaseApi';

/**
 * チャンネルの表示/非表示を更新する。
 */
class UpdateChannelVisibleApi extends BaseApi {
  async post(companyId: string, matchId: string, isHideChannel: boolean) {
    return await this.execute('updateChannelVisibleApi', {
      method: 'POST',
      body: { companyId, matchId, isHideChannel }
    }).then(({ result }) => result);
  }
}

export default UpdateChannelVisibleApi;
